export const emoji = {
  emoticonToEmoji,
  emojiToEmoticon,
};

function emoticonToEmoji(text: string) {
  return text
    .replace(/,:\)/gi, '\u{1F605}')
    .replace(/,:\(/gi, '\u{1F613}')
    .replace(/:\)/gi, '\u{1F642}')
    .replace(/:\|/gi, '\u{1F610}')
    .replace(/;\(/gi, '\u{1F62D}')
    .replace(/:,\(|:'\(/gi, '\u{1F622}')
    .replace(/>:\(/gi, '\u{1F620}')
    .replace(/:P/g, '\u{1F61B}')
    .replace(/:\$/gi, '\u{1F612}')
    .replace(/:@/gi, '\u{1F621}')
    .replace(/<3/gi, '\u{2764}')
    .replace(/;\)/gi, '\u{1F609}')
    .replace(/:,\)|:'\)/gi, '\u{1F602}')
    .replace(/:O/gi, '\u{1F62E}')
    .replace(/:D/gi, '\u{1F604}')
    .replace(/:\(/gi, '\u{1F626}');
}

function emojiToEmoticon(text: string) {
  return text
    .replace(/😅/gi, ',:)')
    .replace(/🙂/gi, ':)')
    .replace(/😦/gi, ':(')
    .replace(/😭/gi, ';(')
    .replace(/😐/gi, ':|')
    .replace(/😢/gi, ':,(')
    .replace(/😠/gi, '>:(')
    .replace(/😛/g, ':P')
    .replace(/😒/gi, ':$')
    .replace(/😡/gi, ':@')
    .replace(/❤/gi, '<3')
    .replace(/😉/gi, ';)')
    .replace(/😂/gi, ":')")
    .replace(/😮/gi, ':O')
    .replace(/😄/gi, ':D')
    .replace(/😓/gi, ',:(');
}

/** Remove all emoticons and emojis from the text provided */
export function removeEmoticonsAndEmojis(text: string) {
  return text
    .replace(/,:\)/gi, '')
    .replace(/,:\(/gi, '')
    .replace(/:\)/gi, '')
    .replace(/:\|/gi, '')
    .replace(/;\(/gi, '')
    .replace(/:,\(|:'\(/gi, '')
    .replace(/>:\(/gi, '')
    .replace(/:P/g, '')
    .replace(/:\$/gi, '')
    .replace(/:@/gi, '')
    .replace(/<3/gi, '')
    .replace(/;\)/gi, '')
    .replace(/:,\)|:'\)/gi, '')
    .replace(/:O/gi, '')
    .replace(/:D/gi, '')
    .replace(/:\(/gi, '')
    .replace(/😅/gi, '')
    .replace(/🙂/gi, '')
    .replace(/😦/gi, '')
    .replace(/😭/gi, '')
    .replace(/😐/gi, '')
    .replace(/😢/gi, '')
    .replace(/😠/gi, '')
    .replace(/😛/g, '')
    .replace(/😒/gi, '')
    .replace(/😡/gi, '')
    .replace(/❤/gi, '')
    .replace(/😉/gi, '')
    .replace(/😂/gi, '')
    .replace(/😮/gi, '')
    .replace(/😄/gi, '')
    .replace(/😓/gi, '');
}
